// Preserve alternate-template navigation in the theme's same-path scroll handler.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-mm-page-link]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const destination = new URL(link.href, location.origin);
  if (destination.origin !== location.origin) return;
  const previewId = new URLSearchParams(location.search).get('preview_theme_id');
  if (previewId) destination.searchParams.set('preview_theme_id', previewId);
  if (destination.pathname === location.pathname && destination.search !== location.search || previewId) {
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(destination.href);
  }
}, true);
